import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'

const HeaderContainer = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 12px 12px 0px 0px;
  font-weight: 500;
  line-height: 21px;
  color: #ffffff;
  font-size: 14px;
  padding: 14px 16px;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 14px 36px;
  }
`

const Basic = styled.div`
  display: flex;
  flex: 4;
`

const No = styled.span`
  display: none;

  ${({ theme }) => theme.mediaQueries.sm} {
    display: flex;
    width: 20px;
  }
`

const Symbol = styled.div`
  display: none;

  ${({ theme }) => theme.mediaQueries.sm} {
    display: flex;
    flex: 2;
  }
`

const Multiplier = styled.div`
  display: none;

  ${({ theme }) => theme.mediaQueries.sm} {
    display: flex;
    flex: 1;
  }
`

const APR = styled.div`
  flex: 1;
  text-align: right;
`

const Liquidity = styled.div`
  flex: 2;
  text-align: right;
`

const FarmsHeader: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <HeaderContainer>
        <Basic>
          <No>#</No> {t('Basic Info')}
        </Basic>
        <Symbol>{t('Symbol')}</Symbol>
        <Multiplier>{t('Multiplier')}</Multiplier>
        <APR>{t('APR')}</APR>
        <Liquidity>{t('Liquidity')}</Liquidity>
      </HeaderContainer>
    </>
  )
}

export default FarmsHeader
